import SlideoverModal from "src/components/SlideoverModal";
import { RootState } from "src/stores";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { queryQueueProps } from "src/interfaces";
import Lucide from "src/base-components/Lucide";
import LoadingIcon from "src/base-components/LoadingIcon";
import { checkPermission, dateParser, isAdmin, isManager } from "src/helpers";
import _ from "lodash";
import { clearAllListeners } from "@reduxjs/toolkit";
import Card from "src/components/Card";
import Button from "src/base-components/Button";
import { updateQueue } from "src/stores/queue";
import { queryAPIUrls } from "src/common/apiActions";
import { assignToWebsiteQueryQueue, fetchWebsiteQueryQueues, updateWebsiteQueryQueue } from "src/stores/websiteQueryQueue";
import { FormInput, FormLabel } from "src/base-components/Form";
import CustomTippy from "src/base-components/customTooltip";
import { getIATACode } from "src/pages/Queries/helpers";
import { DateInput, getCorrectDateFormat } from "src/pages/Queries/UpdateQuery";

interface ComponentProps {
  visible: boolean;
  setVisible: (payload: boolean) => void;
  fetchData: () => void;

  // onUpdate: (payload: {
  //   id: string;
  //   query_id: string;
  //   user_id: number;
  //   callback?: Function;
  // }) => void;
  assignToWebsiteQueryQueue: (payload: {
    id: string;
    query_id: string;
    user_id: number;
    callback?: Function;
  }) => void;
  websiteQueryQueues: queryQueueProps[] | undefined;
  token: any;
}

function Component(props: ComponentProps) {
  const { websiteQueryQueues, fetchData, setVisible, visible, token, assignToWebsiteQueryQueue } =
    props;
  const navigate = useNavigate();
  const [loadingMore, setLoadingMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isLoadedAll, setIsLoadedAll] = useState(false);

  const loadData = () => {

    fetchData();
  };

  useEffect(() => {
    loadData();
    addEventListener("focus", () => {
      if (props?.token && localStorage.getItem("deviceToken")) {
        loadData();
      }
    });
    return () => {
      clearAllListeners();
    };
  }, []);

  return (
    <>
      <SlideoverModal
        className="p-2"
        visible={visible}
        onClose={() => setVisible(false)}
        headerTitle="Website Queries waiting"
      >
        {loading ? (
          <div className="flex w-[100%] justify-center py-16">
            <LoadingIcon
              color="#64748b"
              icon="oval"
              className="w-8 h-8 mx-auto"
            />
          </div>
        ) : websiteQueryQueues?.length == 0 ? (
          <div className="flex w-[100%] justify-center py-28">No Queries</div>
        ) : (
          <div
            onScroll={(event) => {
              const { scrollTop, scrollHeight, clientHeight } =
                event?.currentTarget;
              const distanceFromBottom =
                scrollHeight - scrollTop - clientHeight;
              if (distanceFromBottom == 0 && !isLoadedAll) {
                if (!loadingMore && !loading) {
                  setLoadingMore(true);
                  // loadData(true);
                }
              } else if (distanceFromBottom > 0) {
                setIsLoadedAll(false);
              }
            }}
            className="flex flex-col gap-0.5"
          ></div>
        )}
        <div className="flex flex-col gap-2">
          {!_.isEmpty(websiteQueryQueues) &&
            websiteQueryQueues?.map((item: any, itemKey) => {
              const itineraries = JSON.parse(item?.queries?.query_itinerary_detail ? item?.queries?.query_itinerary_detail : "[]");
              return <Card key={itemKey}>
                <div>
                  <div className="flex justify-between mb-1">
                    <div className="flex items-center text-[#075985] ">
                      {item?.query_no}
                    </div>
                    <div className="text-[12px] text-right">
                      {dateParser(item.updated_at, "DD-MM-YYYY")}
                    </div>
                  </div>
                  <div className="flex justify-between">
                    <div className="flex flex-col gap-2">
                      <div className="">
                        Customer Name:{" "}{item?.queries?.customer?.fullname}
                      </div>
                      <div
                        className=""
                        style={{ lineHeight: "1rem" }}
                      >
                        Customer ID:{" "}
                        {item?.queries?.customer?.customer_id || ""}
                      </div>
                    </div>
                    {/* <div className="flex flex-col leading-4 my-1">
                      <div className="text-[10px] font-medium text-[#075985] text-end ">
                        Payment/Billing Amount:
                      </div>
                      <div className="text-[12px] text-left">
                        ${item?.querie?.payment[0]?.amount}
                      </div>
                    </div> */}
                  </div>
                  {item?.queries?.query_itinerary_detail && <FormLabel className="mt-2">Itinerary details:</FormLabel>}
                  {(item?.queries?.query_itinerary_detail
                    ? Array.isArray(itineraries)
                      ? itineraries
                      : JSON.parse(itineraries)
                    : []).map((field, index) => (
                      <div className="w-full flex gap-2 mb-2" key={index}>
                        {field?.source &&
                          <div className="w-1/3">
                            {index === 0 && <FormLabel className="">Source</FormLabel>}
                            <CustomTippy
                              className="w-full"
                              content={field?.source}
                              theme="light"
                              children={
                                <FormInput
                                  onChange={(e) => {

                                  }}
                                  disabled={true}
                                  name="source"
                                  defaultValue={getIATACode(field?.source).trim().length > 0 ? getIATACode(field?.source) : field?.source}
                                  value={getIATACode(field?.source).trim().length > 0 ? getIATACode(field?.source) : field?.source}
                                  required={true}
                                  className="w-full"
                                />
                              }
                            />

                          </div>}
                        {field?.destination &&
                          <div className="w-1/3">
                            {index === 0 && <FormLabel className="">Destination</FormLabel>}
                            <CustomTippy
                              className="w-full"
                              content={field?.destination}
                              theme="light"
                              children={
                                <FormInput
                                  defaultValue={getIATACode(field?.destination).trim().length > 0 ? getIATACode(field?.destination) : field?.destination}
                                  value={getIATACode(field?.destination).trim().length > 0 ? getIATACode(field?.destination) : field?.destination}
                                  onChange={(e) => {

                                  }}
                                  disabled={true}
                                  name="destination"
                                  required={true}
                                  className="w-full"
                                />
                              }
                            />

                          </div>}
                        {field?.date &&
                          <DateInput
                            date={getCorrectDateFormat(field?.date)}
                            index={index}
                            disabled={true}
                            handleChange={(newDate) => { }}
                            hideTitle={index !== 0}
                          />}
                      </div>
                    ))}

                  <div className="flex flex-row justify-between mb-1">
                    <div className="flex flex-col leading-4 my-1 w-full">
                      {/* <div className="text-[10px] font-medium text-[#075985] text-start ">
                        Assigned by:
                      </div>
                      <div className="text-[12px] text-left">
                        {item?.assigned_by_user?.name}
                      </div> */}
                    </div>
                    <Button
                      variant="outline-primary"
                      className=" font-bold w-32"
                      onClick={() => {
                        // if (item?.status == 0) {
                        if (!item?.assigned_to_user) {
                          assignToWebsiteQueryQueue({
                            id: item?.id,
                            query_id: item?.query_id,
                            user_id: token?.id,
                          })
                        }

                        // }
                        props?.setVisible(false);
                        if (
                          location?.pathname !=
                          `/query-detail/${item?.query_id}`
                        ) {
                          navigate(`/query-detail/${item?.query_id}`);
                        }
                      }}
                    >
                      Proceed
                      <Lucide icon="ArrowRight" className="w-4 h-4 ml-2" />
                    </Button>
                  </div>
                </div>
              </Card>
            })}
        </div>
      </SlideoverModal>
    </>
  );
}

const mapStateToProps = ({ queries, authUser, websiteQueryQueues }: RootState) => ({
  token: authUser,
  websiteQueryQueues: websiteQueryQueues,
});

const mapDispatchToProps = (dispatch: any) => ({
  fetchData: () => dispatch(fetchWebsiteQueryQueues()),
  // onUpdate: (payload: any) => dispatch(updateWebsiteQueryQueue(payload)),
  assignToWebsiteQueryQueue: (payload: any) => dispatch(assignToWebsiteQueryQueue(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Component);
